import { useState } from "react";
import api from "../services/api";

export default function VerifyEmailSent() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const resend = async () => {
    if (!email) return;
    setStatus("Sending...");
    try {
      await api.post("api/auth/resend-verification", { email });
      setStatus("Verification email sent (if account exists)");
    } catch {
      setStatus("Failed to send email");
    }
  };

  return (
    <div className="page-shell flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center">
        <div className="ui-card p-10">
          <h1 className="text-4xl font-extrabold text-secondary mb-4">Check your inbox</h1>
          <p className="text-textMuted mb-8">
            We've sent a verification link to your email. Click it to activate your account.
          </p>

          <div className="space-y-4">
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="ui-input"
            />
            <button
              onClick={resend}
              className="btn-primary w-full py-4"
            >
              Resend Verification Email
            </button>
            {status && <p className="text-sm text-textMuted mt-4">{status}</p>}
          </div>

          <p className="mt-8 text-textMuted">
            <a href="/login" className="font-semibold text-primary hover:underline">
              Back to login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}